import { Ban, CircleCheck, CircleX, Inbox } from '@/lib/icons'
import type { IconType } from '@/lib/icons'
import { BLOGGER_STAGE_LABELS, BloggerStage } from '@ayub/shared'

/**
 * Har bir bosqich uchun ikonka va rang — `docs/04-ui-ux.md`: "Rang hech qachon yagona
 * signal emas" qoidasiga muvofiq, HAR DOIM matn/ikonka bilan birga ishlatiladi.
 *
 * `docs/04` bosqich ranglarini faqat VIDEO varonkasi uchun beradi (Moderatsiya/Joylandi/...).
 * Bloger varonkasi (`BloggerStage`) uchun alohida rang jadvali yo'q, shuning uchun mavjud
 * "shoshilinchlik ranglari" tokenlaridan ma'noga mos qilib olinadi: `NEW` — e'tibor talab
 * qiladi (amber, xuddi "bugun tekshirish kerak" kabi), `ACTIVE` — yakunlangan/ijobiy
 * (yashil), `REJECTED` — salbiy (qizil), `BLOCKED` — neytral kulrang (rad etishdan ham
 * og'irroq holat, lekin alohida rang tanlanmagan — o'rniga `Ban` ikonkasi bilan
 * ajralib turadi) va sarlavhada "Bloklangan" so'zi doim ko'rinadi.
 */
interface StageMeta {
  icon: IconType
  textClass: string
  borderClass: string
  dotClass: string
  subtleClass: string
}

export const BLOGGER_STAGE_META: Record<BloggerStage, StageMeta> = {
  [BloggerStage.NEW]: {
    icon: Inbox,
    textClass: 'text-urgency-today-text',
    borderClass: 'border-urgency-today',
    dotClass: 'bg-urgency-today',
    subtleClass: 'bg-urgency-today/10',
  },
  [BloggerStage.ACTIVE]: {
    icon: CircleCheck,
    textClass: 'text-urgency-done-text',
    borderClass: 'border-urgency-done',
    dotClass: 'bg-urgency-done',
    subtleClass: 'bg-urgency-done/10',
  },
  [BloggerStage.REJECTED]: {
    icon: CircleX,
    textClass: 'text-urgency-overdue-text',
    borderClass: 'border-urgency-overdue',
    dotClass: 'bg-urgency-overdue',
    subtleClass: 'bg-urgency-overdue/10',
  },
  [BloggerStage.BLOCKED]: {
    icon: Ban,
    textClass: 'text-app-hint',
    borderClass: 'border-app-hint',
    dotClass: 'bg-app-hint',
    subtleClass: 'bg-app-hint/10',
  },
}

/**
 * Jadval "Holat" ustuni va kanban kartochkasidagi qisqa nom — shared `BLOGGER_STAGE_LABELS`
 * bilan bir xil (`docs/03-app-flow.md` jadval namunasi: "📥 Yangi", "✅ Faol").
 */
export const stageBadgeLabel = (stage: BloggerStage): string => BLOGGER_STAGE_LABELS[stage]

/**
 * Filtr chiplaridagi nom — `docs/03-app-flow.md`, Sahifa 3:
 * "Hammasi (487) · Yangi ariza (5) · Faol (442) · Rad (31) · Blok (9)".
 * Shared labeldan farq qiladi (masalan "Rad etilgan" emas, qisqa "Rad") — tor chip ichiga
 * sig'ishi uchun hujjatda ataylab qisqartirilgan.
 */
export const STAGE_CHIP_LABELS: Record<BloggerStage, string> = {
  [BloggerStage.NEW]: 'Yangi ariza',
  [BloggerStage.ACTIVE]: 'Faol',
  [BloggerStage.REJECTED]: 'Rad',
  [BloggerStage.BLOCKED]: 'Blok',
}

/**
 * Kanban ustun sarlavhasi — `docs/03-app-flow.md`: "Yangi ariza → Faol → Rad etildi →
 * Bloklangan".
 */
export const STAGE_KANBAN_LABELS: Record<BloggerStage, string> = {
  [BloggerStage.NEW]: 'Yangi ariza',
  [BloggerStage.ACTIVE]: 'Faol',
  [BloggerStage.REJECTED]: 'Rad etildi',
  [BloggerStage.BLOCKED]: 'Bloklangan',
}
